import { View } from './types.js'

const loadSubscription = async (view: View) => {
    const { api } = view

    api.loadSubscription()
}

export const initData = async (view: View) => {
    // Execute in parallel
    await Promise.all([loadSubscription(view)])
}
